import styled, { css } from 'styled-components';
import { Input as AntdInput } from 'antd';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import PhoneInput from 'react-phone-number-input/input';
import theme from '@css/theme';
import { NewLabel } from '@ui-library/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const height = 40;

const common = css<{ isError?: boolean }>`
  border-radius: 2px;
  border: ${({ isError }) => `1px solid ${isError ? theme.color.error : theme.color.border}}`};
  background: #ffffff;
  height: ${height}px;
  padding: 8px 12px;
  width: 100%;
  font-size: 1rem;
  font-weight: normal;
  color: ${theme.text.color.primary};
  line-height: 24px;
  font-family: ${theme.text.fontFamily};
  ::placeholder {
    color: ${theme.color.neutral3};
  }
  &:disabled {
    color: ${theme.text.color.disabled};
    background: ${theme.color.background1};
    ::placeholder {
      color: ${theme.text.color.disabled};
    }
  }
  &:hover {
    border-color: ${({ isError }) => (isError ? theme.color.error : theme.color.border)};
  }
  &:focus {
    border-color: ${({ isError }) => (isError ? theme.color.error : theme.color.rsPrimary)};
    box-shadow: ${({ isError }) => (isError ? 'none' : '0px 0px 4px rgba(24, 144, 255, 0.5)')};
  }
`;

export const Label = styled(NewLabel)`
  margin-bottom: 8px;
`;

export const Input = styled(AntdInput)`
  ${common}
`;

export const Search = styled(AntdInput.Search)`
  ${common}
  border-width: 0;
  padding: 0;
  input {
    height: ${height}px;
    border-color: ${({ isError }) => (isError ? theme.color.error : theme.color.border)};
  }
  button {
    height: ${height}px;
  }
  span {
    left: 0 !important;
  }
`;

export const PasswordIcon = styled(FontAwesomeIcon)`
  color: #193154;
`;

export const PhoneNumber = styled(PhoneInput)`
  ${common}
`;
